import { Menu } from '@mui/material';
import { MenuItem } from '@mui/material';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../redux';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { TAlert } from '../../../types/types';
import * as CSS from 'csstype';
import Tooltip from '@mui/material/Tooltip';
import { NotificationDialog } from '../../CommonFunctions/DialogComponents';
import { setPageSettings } from '../../../redux/PageSettings/DownloadPageSettingsActions';
import { resetAllStates } from '../../../redux/TabTile/TabTileActionsAndMultipleDispatches';
import { toggleDashMode } from '../../../redux/TabTile/TabTileActionsAndMultipleDispatches';
import { toggleDashModeInTab } from '../../../redux/TabTile/TabActions';
import SharedLinks from '../SharedLinks';
import SharePlaybookDialog from '../SharePlaybookDialog';

const DataViewerMenu = ({
  disableEdit,
  openFileMenu,
  anchorEl,

  handleSave,
  setOpenFileMenu,
  setAnchorEl,
  setSaveModal,
  setSaveFromHomeIcon,

  showListofTileMenu,
  setShowListofTileMenu,
  dashboardResizeColumn,
  setDashboardResizeColumn,
  showDashboardFilter,
  setShowDashboardFilter,
  showDashboardFilterEdit,
  setShowDashboardFilterEdit,
  iconAlign,
  setIconAlign,
  reportFilterMenu,
  setReportFilterMenu,
  parameterMenu,
  setParameterMenu,
  textColor,
  backgroundColor,
  borderColor,
}: {
  disableEdit?: boolean;
  openFileMenu: boolean;
  anchorEl: null | HTMLElement;

  setOpenFileMenu: React.Dispatch<React.SetStateAction<boolean>>;
  setAnchorEl: React.Dispatch<React.SetStateAction<null | HTMLElement>>;
  setSaveModal: React.Dispatch<React.SetStateAction<boolean>>;
  setSaveFromHomeIcon: React.Dispatch<React.SetStateAction<boolean>>;
  handleSave: (saveFromHome?: boolean) => Promise<void>;

  showListofTileMenu?: boolean;
  setShowListofTileMenu?: React.Dispatch<React.SetStateAction<boolean>>;
  dashboardResizeColumn?: boolean;
  setDashboardResizeColumn?: React.Dispatch<React.SetStateAction<boolean>>;
  showDashboardFilter?: boolean;
  setShowDashboardFilter?: React.Dispatch<React.SetStateAction<boolean>>;
  showDashboardFilterEdit?: boolean;
  setShowDashboardFilterEdit?: React.Dispatch<React.SetStateAction<boolean>>;
  iconAlign?: 'left' | 'right';
  setIconAlign?: React.Dispatch<React.SetStateAction<'left' | 'right'>>;
  reportFilterMenu?: boolean;
  setReportFilterMenu?: (value: boolean) => void;
  parameterMenu?: boolean;
  setParameterMenu?: (value: boolean) => void;
  textColor?: string;
  backgroundColor?: string;
  borderColor?: string;
}) => {
  const { playbookState, tabTileProps, tabState } = useSelector((state: RootState) => ({
    playbookState: state.playBookState,
    tabTileProps: state.tabTileProps,
    tabState: state.tabState,
  }));

  const location = useLocation();
  const state = location.state;
  const dispatch = useDispatch<any>();

  const locationState = useLocation().state;

  const navigate = useNavigate();

  const [searchParams] = useSearchParams();
  const workspaceId = searchParams.get('workspaceId');

  const [alert, setAlert] = useState<null | TAlert>(null);
  const [dashboardAnchorEl, setDashboardAnchorEl] = useState<any>(null);
  const [openDashboardMenu, setOpenDashboardMenu] = useState(false);
  const [showShareDialog, setShowShareDialog] = useState<boolean>(false);
  const [openShareDialog, setopenShareDialog] = useState(false);
  const [filtersAnchorEl, setFiltersAnchorEl] = useState<any>(null);
  const [openFiltersMenu, setOpenFiltersMenu] = useState(false);

  const handleSharePlaybook = () => {
    const { access } = JSON.parse(localStorage.getItem('accountInfo') || '{}');
    sessionStorage.setItem('accessType', access || '');
    if (playbookState.playBookUid && access === 'community') {
      setShowShareDialog(true);
    } else if (playbookState.playBookUid) {
      setopenShareDialog(true);
    } else {
      setOpenFileMenu(false);
      setAlert({
        message: 'Please save the Playbook before sharing it.',
        severity: 'error',
      });
    }
  };

  const fileMenuStyle: CSS.Properties = {
    color: textColor,
    fontSize: '12px',
    padding: '2px 1rem',
    display: 'flex',
  };

  const menuStyle: CSS.Properties = {
    fontSize: '12px',
    padding: '2px 8px',
    margin: 0,
  };

  const boxShadow = textColor === '#ffffff' ? '#808080' : '#333';

  return (
    <>
      <div className="menuItemsGroup">
        <div
          className="menuItem"
          style={{
            color: textColor,
            backgroundColor: backgroundColor,
          }}
          onClick={(e) => {
            setOpenFileMenu(!openFileMenu);
            setAnchorEl(e.currentTarget);
          }}
        >
          <span>File</span>
          <Menu
            open={openFileMenu}
            className="menuPopover"
            anchorEl={anchorEl}
            PaperProps={{
              sx: {
                backgroundColor: backgroundColor,
                boxShadow: `${textColor === '#ffffff' ? '0px 2px 4px rgba(184, 159, 159, 0.5)' : '0px 2px 4px rgba(0, 0, 0, 0.2)'}`,
                width: '120px',
              },
            }}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'left',
            }}
            onClose={() => {
              setAnchorEl(null);
              setOpenFileMenu(false);
            }}
          >
            <MenuItem
              className={disableEdit ? 'disabledOption' : ''}
              sx={fileMenuStyle}
              onClick={() => {
                setSaveFromHomeIcon(false);
                handleSave();
              }}
            >
              Save
            </MenuItem>
            <MenuItem
              className={disableEdit ? 'disabledOption' : ''}
              sx={fileMenuStyle}
              onClick={() => {
                setOpenFileMenu(false);
                setSaveModal(true);
                // playbookState.playBookUid = null; /*	PRS	11/JUN/2022	*/ // playBookUid should only be updated when playbook is actually saved, not here.
              }}
            >
              Save As
            </MenuItem>
            <MenuItem
              className={disableEdit ? 'disabledOption' : ''}
              sx={fileMenuStyle}
              // onClick={() => {
              //   if(playBookState.playBookUid){
              //     setShowShareDialog(true);
              //   }
              //   else{
              //     setOpenFileMenu(false);
              //     setOpenAlert(true);
              //     setSeverity("error");
              //     setTestMessage("Please save the Playbook before sharing it.");
              //   }
              // }}
              onClick={() => {
                setOpenFileMenu(false);
                handleSharePlaybook(); // Add parentheses to call the function
              }}
            >
              Share
            </MenuItem>
            <MenuItem
              className={disableEdit ? 'disabledOption' : ''}
              sx={fileMenuStyle}
              onClick={() => {
                setOpenFileMenu(false);
                dispatch(resetAllStates());
                navigate('/');
              }}
            >
              Close
            </MenuItem>
          </Menu>
        </div>

        <div
          className="menuItem"
          style={{ color: textColor, backgroundColor: backgroundColor }}
          onClick={(e) => {
            setOpenDashboardMenu(!openDashboardMenu);
            setDashboardAnchorEl(e.currentTarget);
          }}
        >
          <span>Dashboard</span>
          <Menu
            open={openDashboardMenu}
            className="menuPopover"
            anchorEl={dashboardAnchorEl}
            PaperProps={{
              sx: {
                backgroundColor: backgroundColor,
                boxShadow: `${textColor === '#ffffff' ? '0px 2px 4px rgba(184, 159, 159, 0.5)' : '0px 2px 4px rgba(0, 0, 0, 0.2)'}`,
              },
            }}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'left',
            }}
            onClose={() => {
              setDashboardAnchorEl(null);
              setOpenDashboardMenu(false);
            }}
          >
            <MenuItem
              sx={{
                color: tabTileProps.showDash ? '' : '#B4B4B8',
                ...fileMenuStyle,
                '&.MuiMenuItem-root': {
                  cursor: tabTileProps.showDash ? '' : 'not-allowed',
                },
              }}
              onClick={(event) => {
                if (!tabTileProps.showDash) {
                  event.preventDefault();
                } else {
                  setOpenDashboardMenu(false);
                  dispatch(toggleDashMode('Present'));
                  dispatch(toggleDashModeInTab(tabTileProps.selectedTabId, 'Present'));
                  setTimeout(() => {
                    dispatch(setPageSettings('downloadType', 'pdf'));
                    dispatch(setPageSettings('openPageSettingPopover', true));
                    dispatch(setPageSettings('fullScreen', true));
                  }, 200);
                }
              }}
            >
              Download PDF
            </MenuItem>
            <MenuItem
              sx={{
                color: tabTileProps.showDash ? '' : '#B4B4B8',
                ...fileMenuStyle,
                '&.MuiMenuItem-root': {
                  cursor: tabTileProps.showDash ? '' : 'not-allowed',
                },
              }}
              onClick={(event) => {
                if (!tabTileProps.showDash) {
                  event.preventDefault();
                } else {
                  setOpenDashboardMenu(false);
                  dispatch(toggleDashMode('Present'));
                  dispatch(toggleDashModeInTab(tabTileProps.selectedTabId, 'Present'));
                  setTimeout(() => {
                    dispatch(setPageSettings('downloadType', 'image'));
                    dispatch(setPageSettings('openPageSettingPopover', true));
                    dispatch(setPageSettings('fullScreen', true));
                  }, 200);
                }
              }}
            >
              Download Image
            </MenuItem>
          </Menu>
        </div>
        {tabTileProps.dashMode === 'Edit' && (
          <Tooltip
            title="Changes will be applied in Present mode"
            arrow
            placement="right"
            slotProps={{
              tooltip: {
                sx: {
                  fontSize: '12px',
                },
              },
            }}
          >
            <div
              className="menuItem"
              style={{ color: textColor, backgroundColor: backgroundColor }}
              onClick={(e) => {
                setOpenFiltersMenu(!openFiltersMenu);
                setFiltersAnchorEl(e.currentTarget);
              }}
            >
              <span>Filters</span>
              <Menu
                open={openFiltersMenu}
                className="menuPopover"
                anchorEl={filtersAnchorEl}
                PaperProps={{
                  sx: {
                    backgroundColor: backgroundColor,
                    boxShadow: `${textColor === '#ffffff' ? '0px 2px 4px rgba(184, 159, 159, 0.5)' : '0px 2px 4px rgba(0, 0, 0, 0.2)'}`,
                  },
                }}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'left',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'left',
                }}
                onClose={() => {
                  setFiltersAnchorEl(null);
                  setOpenFiltersMenu(false);
                }}
              >
                <MenuItem
                  sx={{
                    color: tabTileProps.showDash ? '' : '#B4B4B8',
                    ...fileMenuStyle,
                    '&.MuiMenuItem-root': {
                      cursor: tabTileProps.showDash ? '' : 'not-allowed',
                    },
                  }}
                  onClick={(event) => {
                    if (!tabTileProps.showDash) {
                      event.preventDefault();
                    } else {
                      if (setShowDashboardFilter) {
                        if (
                          (parameterMenu === false && reportFilterMenu === true) ||
                          (parameterMenu === true && reportFilterMenu === true)
                        )
                          setShowDashboardFilter(true);
                        else {
                          setShowDashboardFilter(!showDashboardFilter);
                        }
                      }

                      if (setParameterMenu) {
                        if (parameterMenu === false) setParameterMenu(true);
                        else setParameterMenu(false);
                      }

                      setOpenFiltersMenu(false);
                    }
                  }}
                >
                  {parameterMenu ? 'Hide Parameters' : 'Show Parameters'}
                </MenuItem>
                <MenuItem
                  sx={{
                    color: tabTileProps.showDash ? '' : '#B4B4B8',
                    ...fileMenuStyle,
                    '&.MuiMenuItem-root': {
                      cursor: tabTileProps.showDash ? '' : 'not-allowed',
                    },
                  }}
                  onClick={(event) => {
                    if (!tabTileProps.showDash) {
                      event.preventDefault();
                    } else {
                      if (setShowDashboardFilter) {
                        if (
                          (reportFilterMenu === false && parameterMenu === true) ||
                          (parameterMenu === true && reportFilterMenu === true)
                        )
                          setShowDashboardFilter(true);
                        else {
                          setShowDashboardFilter(!showDashboardFilter);
                        }
                      }

                      if (setReportFilterMenu) {
                        if (reportFilterMenu === false) setReportFilterMenu(true);
                        else setReportFilterMenu(false);
                      }

                      setOpenFiltersMenu(false);
                    }
                  }}
                >
                  {reportFilterMenu ? 'Hide Report Filters' : 'Show Report Filters'}
                </MenuItem>
                <MenuItem
                  sx={{
                    color: tabTileProps.showDash ? '' : '#B4B4B8',
                    ...fileMenuStyle,
                    '&.MuiMenuItem-root': {
                      cursor: tabTileProps.showDash ? '' : 'not-allowed',
                    },
                    display: 'flex',
                    justifyContent: 'flex-start',
                    gap: '8px',
                  }}
                  onClick={(event) => {
                    if (!tabTileProps.showDash) {
                      event.preventDefault();
                    } else {
                      if (setIconAlign) setIconAlign(iconAlign === 'left' ? 'right' : 'left');
                      setOpenFiltersMenu(false);
                    }
                  }}
                >
                  {iconAlign === 'left' ? 'Right Alignment' : 'Left Alignment'}
                </MenuItem>
              </Menu>
            </div>
          </Tooltip>
        )}
      </div>
      {alert && (
        <NotificationDialog
          openAlert={alert !== null}
          severity={alert?.severity}
          testMessage={alert?.message}
          onCloseAlert={() => setAlert(null)}
        />
      )}
      <SharePlaybookDialog
        open={openShareDialog}
        onClose={() => setopenShareDialog(false)}
        playBookUid={playbookState.playBookUid}
      />

      {showShareDialog && (
        <SharedLinks
          playBookId={playbookState.playBookUid}
          showPopup={showShareDialog}
          handleCloseButtonClick={() => setShowShareDialog(false)}
        />
      )}
    </>
  );
};

export default DataViewerMenu;
